'use client'

interface BookingBackButtonProps {
    onClick: () => void
    label: string
    isLoading?: boolean
    'data-testid'?: string
}

export default function BookingBackButton({
    onClick,
    label,
    isLoading = false,
    'data-testid': testId = 'booking-back-button'
}: BookingBackButtonProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={isLoading}
            className="flex items-center gap-1 text-sm widget-text-secondary hover:widget-text-primary transition-colors self-start cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed mb-4"
            data-testid={testId}
        >
            <svg className="size-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
            {label}
        </button>
    )
}
